/* eslint-disable filenames/match-regex */
// Media Platform Buttons - components > mediaButtons
export const GOOGLE_ONE_TAP = {
  anErrorOccured: 'An error occured',
  invalidGoogleTokenId: 'Invalid google token id',
};
export const PREFORMATTED_STRING = {
  brandTerminology: {
    brand: '5pm',
    wowcher_or_voucher: 'voucher',
    Wowcher_or_voucher: 'voucher',
    wowchers_or_vouchers: 'vouchers',
    Wowchers_or_vouchers: 'vouchers',
  },
};
